import { useSuspenseQuery } from '@tanstack/react-query';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';
import type { MarketingProcess } from 'types/shared';
import { apiClient } from 'lib/api';

export interface AdsHistoryFilterOption {
  id: number;
  name: string;
}

export interface AdsHistoryFilterOptions {
  hypothesis: AdsHistoryFilterOption[];
  customer: AdsHistoryFilterOption[];
  technology: AdsHistoryFilterOption[];
  flow: AdsHistoryFilterOption[];
}

interface GetAdsHistoryFilterOptionsParams {
  marketing_process?: MarketingProcess;
}

export const getAdsHistoryFilterOptions = async (
  params?: GetAdsHistoryFilterOptionsParams,
  signal?: AbortSignal,
): Promise<AdsHistoryFilterOptions> => {
  const res = await apiClient.get<AdsHistoryFilterOptions>(queryKeys.adsHistoryFilterOptions, {
    signal,
    params,
  });

  return res.data;
};

interface UseAdsHistoryFilterOptionsOptions<TData> {
  config?: QueryConfig<typeof getAdsHistoryFilterOptions, TData>;
  params?: GetAdsHistoryFilterOptionsParams;
}

export const useAdsHistoryFilterOptions = <TData = AdsHistoryFilterOptions>(
  { config, params }: UseAdsHistoryFilterOptionsOptions<TData> = {},
) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getAdsHistoryFilterOptions(params, signal),
    queryKey: [queryKeys.adsHistoryFilterOptions, params?.marketing_process],
  });
};
